export default __webpack_public_path__ + "static/media/resteo.9eadcc60.png";